import React, { useState, useReducer } from 'react';
import useAuth from '../../../hooks/useAuth';
import { useHistory, useNavigate } from 'react-router-dom';
import Validation from '../../../utils/Validation';
import _ from "lodash";
// import { ChangePasswords } from '../../../actions/authAction';
import { toast } from 'react-hot-toast';
import Loader from '../../../utils/Loader';
import Reducer from '../../../services/Reducer';
import { changeAdminPassword } from '../../../actions/authAction';
import { logout } from '../../../redux/slice/user';
import { useDispatch } from 'react-redux';

const initState = {
    oldPassword: '',
    newPassword: '',
    password_confirmation: '',
    loading: false,
    validate: false
};

const passwordState = {
    oldPassErrBlank: false,
    // IsValidOldPass: false,
    IsExistOldPass: false,

    passErrBlank: false,
    IsValidPass: false,

    confirmPassErrBlank: false
};

function ChangePasssword() {
    const [state, dispatch] = useReducer(Reducer, initState);
    const reduxDispatch = useDispatch()
    const navigator = useNavigate()
    const [stateForErr, dispatchForErr] = useReducer( Reducer , passwordState);
    const [togglePassword, setTogglePassword] = useState(false)
    const [togglePassword2, setTogglePassword2] = useState(false)
    const [toggleOldPassword, setToggleOldPassword] = useState(false)

    const { Logout } = useAuth();

    const onPasswordChange = async (e) => {
        e.preventDefault();
        dispatch({ type: 'VALIDATE', payload: true });
        let validationStatus = await getValidation();

        if (validationStatus) {
            dispatch({ type: 'LOAD', payload: true });
            const payload = {
                oldPassword: state.oldPassword,
                newPassword: state.newPassword
            };

            const response = await changeAdminPassword(payload);
            console.log("Change password response:", response);
            if (response) {
                if (response?.data?.success) {
                    dispatch({ type: 'LOAD', payload: false });
                    // Ensure toast shows for 3 seconds
                    dispatch({ type: "SETDATA", payload: { "name": "oldPassword", "value": '' } })
                    dispatch({ type: "SETDATA", payload: { "name": "newPassword", "value": '' } })
                    dispatch({ type: "SETDATA", payload: { "name": "password_confirmation", "value": '' } })
                    toast.success("Password changed successfully", { 
                        position: 'top-right',
                        duration: 3000 
                    });
                    setTimeout(() => {
                        navigator('/user/dashboard')
                    }, 3000)

                }
                 else {
                    dispatch({ type: 'LOAD', payload: false });

                
                        toast.error(response.data.message||"Something went wrong!", {
                            position: 'top-right',
                            duration: 4000,
                        })
                        dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistOldPass', value: true } });
                    

                }
            } else {
                toast.error("Something went wrong", {
                    position: 'top-right',
                    duration: 4000,
                });
                console.log('Error');
            }
        }
    };

    const getValidation = () => {
        return new Promise((resolve, reject) => {
            if (
                Validation.text(state.oldPassword) &&
                Validation.text(state.newPassword) &&
                Validation.passwordCheck(state.newPassword) &&
                Validation.passwordConfirmCheck(state.newPassword, state.password_confirmation)
            ) {
                resolve(true)
            } else {
                // Show specific error messages for each field
                if (!Validation.text(state.oldPassword)) {
                    toast.error('Old password is required', {
                        position: 'top-right',
                        duration: 4000,
                    });
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'oldPassErrBlank', value: true } });
                }
                if (!Validation.text(state.newPassword)) {
                    toast.error('New password is required', {
                        position: 'top-right',
                        duration: 4000,
                    });
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'passErrBlank', value: true } });
                }
                else if (!Validation.passwordCheck(state.newPassword)) {
                    toast.error('Password must be at least 8 characters with uppercase, lowercase, number, and special character', {
                        position: 'top-right',
                        duration: 5000,
                    });
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPass', value: true } });
                }
                if (!Validation.passwordConfirmCheck(state.newPassword, state.password_confirmation)) {
                    toast.error('Confirm password does not match new password', {
                        position: 'top-right',
                        duration: 4000,
                    });
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'confirmPassErrBlank', value: true } });
                }

                resolve(false)
            }
        });
    }
    const getData = (e) => {
        // Clear old password errors when user starts typing
        if (e.target.name === "oldPassword") {
            if (stateForErr.IsExistOldPass) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistOldPass', value: false } });
            }
            if (stateForErr.oldPassErrBlank) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'oldPassErrBlank', value: false } });
            }
        }

        if (e.target.name === "newPassword") {
            // Clear errors when user starts typing
            if (stateForErr.passErrBlank) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'passErrBlank', value: false } });
            }
            if (stateForErr.IsValidPass) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPass', value: false } });
            }

            if (!Validation.text(e.target.value)) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'passErrBlank', value: true } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPass', value: false } });
            }
            else if (!Validation.passwordCheck(e.target.value)) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'passErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPass', value: true } });
            } else {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'passErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPass', value: false } });
            }
            if (!Validation.passwordConfirmCheck(e.target.value, state.password_confirmation)) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'confirmPassErrBlank', value: true } });
            } else {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'confirmPassErrBlank', value: false } });
            }
        }

        if (e.target.name === "password_confirmation") {
            // Clear error when user starts typing
            if (stateForErr.confirmPassErrBlank) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'confirmPassErrBlank', value: false } });
            }

            if (!Validation.passwordConfirmCheck(state.newPassword, e.target.value)) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'confirmPassErrBlank', value: true } });
            } else {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'confirmPassErrBlank', value: false } });
            }
        }

        dispatch({ type: "ONCHANGE", payload: e })
    }
    return (
        <>
        <div className="createNewAccountPage" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <div className="createNewAccountInner" style={{ width: '100%', maxWidth: '500px' }}>
                <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}> Change Password</h1>
                <form className=''>
                    <div className="row justify-content-center">
                        {/* <div className="col-md-12">
                                <h4>Contact Person Details</h4>
                            </div> */}
                        <div className="col-md-12">
                            <div className="formGroup">
                                <label>Old Password</label>
                                <div className="inputgroup inputgroupRight">
                                    <input type={ !toggleOldPassword ? "password" : "text" } id="oldPassword"
                                        value={state.oldPassword}
                                        onChange={getData}
                                        name="oldPassword"
                                        className={(stateForErr.oldPassErrBlank || stateForErr.IsExistOldPass) ? "form-control red-border" : "form-control"}
                                         />
                                    <span onClick={() => setToggleOldPassword(!toggleOldPassword)} style={{ cursor: "pointer" }}
                                        className="rightSide">
                                        <i className="material-icons" style={{ color: 'white' }}>{toggleOldPassword ? 'visibility' : 'visibility_off'}</i>
                                    </span>
                                </div>
                                {stateForErr.oldPassErrBlank &&
                                    <p className="error-msg">Password is required.</p>
                                }
                                
                                {stateForErr.IsExistOldPass &&
                                    <p className="error-msg">Wrong old password.</p>
                                }
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="formGroup">
                                <label>New Password</label>
                                <div className="inputgroup inputgroupRight">
                                    <input id="newPassword"
                                        value={state.newPassword}
                                        onChange={getData}
                                        name="newPassword"
                                        className={(stateForErr.passErrBlank || stateForErr.IsValidPass) ? "form-control red-border" : "form-control"}
                                        type={!togglePassword ? "password" : "text"}
                                        placeholder="" />
                                    <span onClick={() => setTogglePassword(!togglePassword)} style={{ cursor: "pointer" }}
                                        className="rightSide">
                                        <i className="material-icons" style={{ color: 'white' }}>{togglePassword ? 'visibility' : 'visibility_off'}</i>
                                    </span>
                                </div>
                                {stateForErr.passErrBlank &&
                                    <p className="error-msg">Password is required.</p>
                                }
                                {stateForErr.IsValidPass &&
                                    <p className="error-msg">Please enter valid password minimum 8 characters with at least a number,
                                        special character and capital letter and small letter.</p>
                                }
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="formGroup">
                                <label>Confirm New Password</label>
                                <div className="inputgroup inputgroupRight">
                                    <input id="password_confirmation"
                                        value={state.password_confirmation}
                                        onChange={getData}
                                        type={!togglePassword2 ? "password" : "text"}
                                        name="password_confirmation"
                                        className={(stateForErr.confirmPassErrBlank) ? "form-control red-border" : "form-control"} placeholder="" />
                                    <span onClick={() => setTogglePassword2(!togglePassword2)} style={{ cursor: "pointer" }}
                                        className="rightSide">
                                        <i className="material-icons" style={{ color: 'white' }}>{togglePassword2 ? 'visibility' : 'visibility_off'}</i>
                                    </span>
                                </div>
                                {stateForErr.confirmPassErrBlank &&
                                    <p className="error-msg">Confirm Password is not matched with New Password.</p>
                                }
                            </div>
                        </div>
                        <div class="col-12" style={{ textAlign: 'center', marginTop: '2rem' }}>
                            <button disabled={state.loading ? true : false} class="themeBtn fullBtn" onClick={onPasswordChange} style={{ maxWidth: '300px' }}>
                                {
                                    state.loading ? <Loader loaderWidth={"30px"} loaderHeight={"30px"} position={"relative"} /> : "Change Password"
                                }

                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        
        </>
    )
}

export default ChangePasssword;
